import React, { useState } from 'react'
import InnerBanner from '../../../Components/InnerBanner/InnerBanner'
import { Col, Container, Row, Button, Spinner, Alert, Dropdown } from 'react-bootstrap'
import { useSearchUsers, useLikeUser, usePassUser } from '../../../Hooks/useMatching'
import BasicFilters from '../../../Components/BasicFilters/BasicFilters'
import './InteractWithHappiness.css'
import verifiedIcon from '../../../assets/images/verified-badge.png';
import { FaCheck, FaFilter, FaStar, FaTimes, FaUserAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom';

const InteractWithHappiness = () => {
    const [currentUserIndex, setCurrentUserIndex] = useState(0)
    const [searchFilters, setSearchFilters] = useState({})
    const navigate = useNavigate();
    // Fetch users using react-query
    const {
        data: users = [],
        isLoading,
        error,
        refetch
    } = useSearchUsers(searchFilters)

    // Mutations for like and pass actions
    const likeMutation = useLikeUser()
    const passMutation = usePassUser()

    const currentUser = users[currentUserIndex]

    console.log(currentUser, 'currentUserssssssssssssssss')

    const handleLike = async () => {
        if (!currentUser) return

        try {
            await likeMutation.mutateAsync(currentUser.id)
            // Move to next user after successful like
            setCurrentUserIndex(prev => prev + 1)
        } catch (error) {
            console.error('Failed to like user:', error)
        }
    }

    const handlePass = async () => {
        if (!currentUser) return

        try {
            await passMutation.mutateAsync(currentUser.id)
            // Move to next user after successful pass
            setCurrentUserIndex(prev => prev + 1)
        } catch (error) {
            console.error('Failed to pass user:', error)
        }
    }

    const handleRefresh = () => {
        setCurrentUserIndex(0)
        refetch()
    }

    const handleApplyFilters = (filters) => {
        setSearchFilters(filters)
        setCurrentUserIndex(0)
        // The useSearchUsers hook will automatically refetch with new filters
    }

    const handleClearFilters = () => {
        setSearchFilters({})
        setCurrentUserIndex(0)
    }

    if (isLoading) {
        return (
            <>
                <InnerBanner heading="Interact With Happiness" />
                <section className="py-sm-5 py-4">
                    <Container>
                        <Row>
                            <Col xs={12} className="text-center">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                                <p className="mt-3">Finding your perfect matches...</p>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </>
        )
    }

    if (error) {
        return (
            <>
                <InnerBanner heading="Interact With Happiness" />
                <section className="py-sm-5 py-4">
                    <Container>
                        <Row>
                            <Col xs={12}>
                                <Alert variant="danger">
                                    <Alert.Heading>Oops! Something went wrong</Alert.Heading>
                                    <p>{error.message || 'Failed to load users. Please try again.'}</p>
                                    <Button variant="outline-danger" onClick={handleRefresh}>
                                        Try Again
                                    </Button>
                                </Alert>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </>
        )
    }

    if (!currentUser && users.length === 0) {
        return (
            <>
                <InnerBanner heading="Interact With Happiness" />
                <section className="py-sm-5 py-4">
                    <Container>
                        <Row>
                            <Col xs={12} className="text-center">
                                <div className="interact-card-wrapper">
                                    <h3>No more profiles to show!</h3>
                                    <p>Check back later for new matches or adjust your preferences.</p>
                                    <Button variant="primary" onClick={handleRefresh}>
                                        Refresh
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </>
        )
    }

    return (
        <>
            <InnerBanner heading="Interact With Happiness" />
            <section className="py-sm-5 py-4">
                <Container>
                    <Row>
                        <Col xs={12} className='my-3'>
                            <div className="interact-card-wrapper">
                                <Dropdown className='mb-3 match-filter-dropdown' autoClose={false}>
                                    <Dropdown.Toggle className='match-filter-dropdown-toggle' id="dropdown-basic">
                                        <FaFilter />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu align='end'>
                                        <BasicFilters 
                                            onApply={handleApplyFilters}
                                            onClear={handleClearFilters}
                                            initialFilters={searchFilters}
                                        />
                                    </Dropdown.Menu>
                                </Dropdown>
                                {currentUser && (
                                    <div className="profile-card">
                                        <div className="profile-card-top">
                                            <span className="profile-location fw-regular">30 km away</span>
                                            <button className="profile-visit-btn" onClick={()=>navigate(`/user/profile/${currentUser.id}`)}><FaUserAlt /></button>
                                        </div>
                                        <div className="profile-image-container">
                                            <img
                                                src={currentUser.image || '/default-profile.png'}
                                                alt={currentUser.full_name || currentUser.username}
                                                className="profile-image"
                                            />
                                            <div className="profile-info">
                                                <h4 className='mb-0 fw-medium d-flex align-items-center justify-content-center gap-1'>
                                                    <span>{currentUser.full_name || currentUser.username}</span>,
                                                    {currentUser.date_of_birth &&
                                                        <span>{new Date().getFullYear() - new Date(currentUser.date_of_birth).getFullYear()}
                                                        </span>} {currentUser.email_verified_at && <img width={25} src={verifiedIcon} alt="Verified" className="img-fluid" />}</h4>
                                            </div>
                                        </div>

                                        <div className="action-buttons p-0 pt-3">
                                            <Button
                                                variant="danger"
                                                size="lg"
                                                className="action-btn pass-btn"
                                                onClick={handlePass}
                                                disabled={passMutation.isPending}
                                            >
                                                {passMutation.isPending ? (
                                                    <Spinner size="sm" />
                                                ) : (
                                                    <FaTimes size={20} />
                                                )}
                                            </Button>
                                            <Button
                                                variant="light"
                                                size="lg"
                                                className="action-btn starred-btn"
                                            // onClick={handlePass}
                                            // disabled={passMutation.isPending}
                                            >
                                                <FaStar size={20} />
                                            </Button>

                                            <Button
                                                variant="success"
                                                size="lg"
                                                className="action-btn like-btn"
                                                onClick={handleLike}
                                                disabled={likeMutation.isPending}
                                            >
                                                {likeMutation.isPending ? (
                                                    <Spinner size="sm" />
                                                ) : (
                                                    <FaCheck size={20} />
                                                )}
                                            </Button>
                                        </div>
                                    </div>
                                )}

                                {currentUserIndex >= users.length && (
                                    <div className="no-more-profiles">
                                        <h3>No more profiles to show!</h3>
                                        <p>Check back later for new matches.</p>
                                        <Button variant="primary" onClick={handleRefresh}>
                                            Refresh
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default InteractWithHappiness
